import { AxiosRequestConfig } from 'axios';
import apiRequest from '@/util/api-request';

class ApiRequestWrapper {
    private static promises: { [key: string]: Promise<any> } = {}; // リクエストの結果を格納するオブジェクト

    // ハッシュを生成する関数
    private static async generateHash(payload: any): Promise<string> {
        const encoder = new TextEncoder(); // テキストエンコーダを作成
        const data = encoder.encode(JSON.stringify(payload)); // ペイロードをJSON文字列に変換してエンコード
        const hashBuffer = await crypto.subtle.digest('SHA-256', data); // SHA-256ハッシュを生成
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // バッファを配列に変換
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // 16進数に変換
        return hashHex;
    }

    static async request(method: 'post' | 'get', url: string, payload: any = {}) {
        const payloadHash = await this.generateHash(payload); // ペイロードのハッシュを生成
        const key = `${method}-${url}-${payloadHash}`; // 一意のキーを生成（メソッド、URL、ハッシュの組み合わせ）
        if (!this.promises[key]) { // まだこのキーのリクエストが存在しない場合
            this.promises[key] = (async () => {
                try {
                    const config: AxiosRequestConfig = {
                        method,
                        url,
                        data: method === 'post' ? payload : undefined, // POSTの場合はdataを設定
                    };
                    const result = await apiRequest(config); // APIリクエストを実行
                    delete this.promises[key]; // 呼び出しが完了したらプロミスを削除
                    return result;
                } catch (e) {
                    delete this.promises[key]; // エラーが発生した場合もプロミスを削除
                    throw e;
                }
            })();
        }

        return this.promises[key]; // 既存のプロミスを返す
    }
}

export default ApiRequestWrapper;